import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, SUPPORTED_LANGS } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "mexihome5_lang";

function detectInitial() {
  if (typeof window === "undefined") return "pt";
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && translations[saved]) return saved;
  const nav = (navigator.language || "pt").slice(0, 2).toLowerCase();
  return translations[nav] ? nav : "pt";
}

// Deep-merge over PT (canonical) so any missing key in another locale silently falls back
function deepMerge(base, override) {
  if (Array.isArray(override)) return override;
  if (typeof override !== "object" || override === null) return override;
  const out = { ...base };
  for (const k of Object.keys(override)) {
    out[k] = k in base ? deepMerge(base[k], override[k]) : override[k];
  }
  return out;
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectInitial);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = useMemo(() => {
    const t = deepMerge(translations.pt, translations[lang] || {});
    return { lang, setLang, t, supported: SUPPORTED_LANGS };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used inside LanguageProvider");
  return ctx;
}
